import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { Account, Customer } from '../../models/customer';
import { State } from '../../services/global-state';
import { Business } from '../../models/business';
import { EventAggregator } from 'aurelia-event-aggregator';
import { mock, instance, when, verify, resetCalls } from 'ts-mockito';
import { SetupInstallments } from './setup-installment';
import { PayrazrService } from '../../services/payrazr';
import { Installment } from '../../models/installment';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('installments', () => {
			describe('setup-installments', () => {
				const mockRouter: Router = mock(Router);
				const mockI18N: I18N = mock(I18N);
				const mockEventAggregator: EventAggregator = mock(EventAggregator);
				const mockBusiness: Business = mock(Business);
				const mockPayrazrService: PayrazrService = mock(PayrazrService);
				const mockAccount: Account = mock(Account);
				const mockInstallment: Installment = mock(Installment);
				const mockCustomer: Customer = mock(Customer);

				let component: SetupInstallments;
				let stubState: State;

				let mockRouteData = {
					installment: mockInstallment,
					overrides: null,
					negotiatorActivitySessionId: null,
					accounts: []
				};

				let portalSettings = {
					portfolioKey: 999999,
					name: 'Test Portfolio',
					settings: {
						paymentTypes: {
							installments: {
								maxFirstInstallmentFutureDays: 10
							},
						},
					},
					merchantSettings: {
						merchantKey: 999999,
						zid: 'Z999999',
						feeSettings: {
							allowServiceFeesOnEveryTransaction: false,
						}
					}
				};

				beforeEach(() => {
					stubState = new State(
						instance(mockI18N),
						instance(mockEventAggregator)
					);

					stubState.customer = instance(mockCustomer);
					stubState.business = instance(mockBusiness);
					spyOn(stubState.business, 'fetchPortfolioSettings').and.callFake(() => portalSettings);

					component = new SetupInstallments(
						instance(mockRouter),
						stubState,
						instance(mockPayrazrService),
						instance(mockI18N)
					);

					resetCalls(mockRouter);
				});

				afterEach(() => {
					component.account = null;
				});

				describe('activate()', () => {
					let account = instance(mockAccount);
					const model = { id: '123' };

					beforeEach(() => {
						// create accounts and add single account
						stubState.customer.accounts = Array<Account>();
						account.id = '123';
						account.portfolioName = 'portfolioName';
						stubState.accounts.push(account);
						stubState.customer.portfolios = { portfolioName: 'portfolioName' };

						mockRouteData.accounts.push(account);
					});

					afterEach(() => {
						// reset mockRouteData
						mockRouteData = {
							installment: mockInstallment,
							overrides: null,
							negotiatorActivitySessionId: null,
							accounts: []
						};
					});

					it('should set max future to installment setting value without overrides', () => {
						expect(component.maxFuture).toBe(60); // value set in ctor
						component.activate(model, mockRouteData);
						expect(component.maxFuture).toBe(portalSettings.settings.paymentTypes.installments.maxFirstInstallmentFutureDays);
					});

					it('should set max future to installment setting value with overrides', () => {
						mockRouteData.overrides = { selectedFrequency: 'Daily' };
						expect(component.maxFuture).toBe(60); // value set in ctor
						component.activate(model, mockRouteData);
						expect(component.maxFuture).toBe(portalSettings.settings.paymentTypes.installments.maxFirstInstallmentFutureDays);
					});
				});
			});
		});
	});
});
